import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/views/layout/Layout'

//
Vue.use(Router)

/** note: submenu only apppear when children.length>=1
 *   detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']     will control the page roles (you can set multiple roles)
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 noCache: true                if true ,the page will no be cached(default is false)
 }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // { path: '/authredirect', component: () => import('@/views/login/authredirect'), hidden: true },
  // { path: '/404', component: () => import('@/views/errorPage/404'), hidden: true },
  // { path: '/401', component: () => import('@/views/errorPage/401'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [{
      path: 'index',
      component: () => import('@/views/dashboard/index'),
      name: 'index',
      meta: {title: 'dashboard', icon: 'dashboard', chineseName: '管理后台-dashboard'}
    }]
  },
  // {
  //   path: '/fullScreenDashboard/',
  //   component: () => import('@/views/dashboard/screenIndex'),
  //   hidden: true
  // },
  {
    path: '/overview',
    component: () => import('@/views/dashboard/screenIndex'),
    hidden: true
  },
  {
    path: '/office365/callback',
    component: () => import('@/views/office365/callback'),
    hidden: true
  },
  {
    path: '/office365/privacy',
    component: () => import('@/views/office365/privacy'),
    hidden: true
  },
  // {
  //   path: '',
  //   component: Layout,
  //   children: [{
  //     path: 'organizationMge',
  //     component: () => import('@/views/organizationMge/index'),
  //     name: 'organizationMge',
  //     meta: { title: 'organizationMge', icon: 'icon', noCache: true}
  //   }]
  // },
  //
  // {
  //   path: '',
  //   component: Layout,
  //   hidden:permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden,
  //   children: [{
  //     path: 'organizationShoolIndexMge',
  //     component: () => import('@/views/organizationMge/shoolIndex'),
  //     name: 'organizationShoolIndexMge',
  //     meta: { title: 'organizationMge', icon: 'icon', noCache: true }
  //   }]
  // },
  // {
  //   path: '/userMge',
  //   component: Layout,
  //   children: [{
  //     path: 'userMge',
  //     component: () => import('@/views/userMge/index'),
  //     name: 'userMge',
  //     meta: { title: 'userMge', icon: 'icon', noCache: true }
  //   }]
  // },
  // {
  //   path: '/authorityMge',
  //   component: Layout,
  //   redirect: 'authorityMge',
  //   name: 'authorityMge',
  //   meta: {
  //     title: 'authorityMge',
  //     icon: 'component',
  //
  //   },
  //   children: [
  //     { path: 'authorityMge', component: () => import('@/views/authorityMge/index'), name: 'authorityMge', meta: { title: 'authorityMge' }},
  //     { path: 'card', component: () => import('@/views/authorityMge/card'), name: 'cardMge', meta: { title: 'cardMge' }}
  //   ]
  // },
  // {
  //   path: '/Devices',
  //   component: Layout,
  //   hidden:permission.componentModule.V3_0_IQManageCenter_DeviceManage.hidden,
  //   meta: { title: 'Devices', icon: 'icon', noCache: true },
  //   children: [{
  //     path: 'Devices',
  //     component: () => import('@/views/equipmentMge/index'),
  //     name: 'Devices',
  //     meta: { title: 'processorManager'}
  //   },
  //     { path: 'projectorCode', component: () => import('@/views/projectorDevices/index'), name: 'projectorCode', meta: { title: 'projectorCode'}},
  //     { path: 'interfaceRename', component: () => import('@/views/equipmentMge/editName'), name: 'interfaceRename', meta: { title: 'interfaceRename'}}
  //   ]
  // },
  // {
  //   path: '/workstationMge',
  //   component: Layout,
  //   hidden:permission.componentModule.V3_0_IQManageCenter_MediaDeviceManage.hidden,
  //   children: [{
  //     path: 'workstationMge',
  //     component: () => import('@/views/workstationMge/index'),
  //     name: 'workstationMge',
  //     meta: { title: 'workstationMge', icon: 'icon', noCache: true }
  //   }]
  // },
  // {
  //   path: '/cloudDiskMge',
  //   component: Layout,
  //   redirect: 'cloudDiskMge',
  //   hidden:permission.componentModule.V3_0_IQManageCenter_CloudSpaceManage.hidden,
  //   name: 'cloudDiskMge',
  //   meta: {
  //     title: 'cloudDiskMge',
  //     icon: 'component'
  //
  //   },
  //   children: [
  //     { path: 'cloudDiskMge', component: () => import('@/views/cloudDiskMge/index'), name: 'resourceMge', meta: { title: 'resourceMge' }},
  //     { path: 'storageMge', component: () => import('@/views/cloudDiskMge/storageMge'), name: 'storageMge', meta: { title: 'storageMge' }}
  //   ]
  // },
  // {
  //   path: '/operationLog',
  //   component: Layout,
  //   hidden:permission.componentModule.V3_0_IQManageCenter_LoggerManage.hidden,
  //   children: [{
  //     path: 'operationLog',
  //     component: () => import('@/views/operationLog/index'),
  //     name: 'operationLog',
  //     meta: { title: 'operationLog', icon: 'icon', noCache: true }
  //   }]
  // },
]

export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  base: '/dashboard/',//这个配置也很重要，否则会出现页面空白情况
  routes: constantRouterMap
})

export const routesModule = [

  {
    name: 'V3_0_OrgChildManage',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'organizationMge',
        component: '/organizationMge/index',
        name: 'organizationMge',
        meta: {title: 'organizationMge', icon: 'groups', noCache: true, chineseName: '代理商管理平台-组织管理'},
        setName: 'V3_0_OrganizationManage'
      }]
    },
  },
  {
    name: 'V3_0_OrganizationManage',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'organizationShoolIndexMge',
        component: '/organizationMge/shoolIndex',
        name: 'organizationShoolIndexMge',
        meta: {title: 'organizationMge', icon: 'groups', noCache: true, chineseName: '管理后台-组织管理'},
        setName: 'V3_0_OrganizationManage1'
      }]
    },
  },
  {
    name: 'V3_0_UserManage',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'userMge',
        component: '/userMge/index',
        name: 'userMge',
        meta: {title: 'userMge', icon: 'user', noCache: true, chineseName: '管理后台-用户管理'},
        setName: 'V3_0_UserManage',
      }]
    },
  },
  // {
  //   name:'V3_0_AuthorityMge',
  //   routes:{
  //     path: '',
  //     component: 'Layout',
  //     redirect: 'authorityMge',
  //     name: 'authorityMge',
  //     // meta: {
  //     //   title: 'authorityMge',
  //     //   icon: 'permission',
  //     // },
  //     setName:'V3_0_AuthorityMge',
  //     children: [
  //       { path: 'authorityMge', component: '/authorityMge/index', name: 'authorityMge', meta: { title: 'roleMge',icon: 'permission',chineseName:'管理后台-角色权限管理' }},
  //       // { path: 'card', component: '/authorityMge/card', name: 'cardMge', meta: { title: 'cardMge' }}
  //     ]
  //   },
  // },

  {
    name: 'V3_0_DeviceManage',
    routes: {
      path: '',
      component: 'Layout',
      meta: {title: 'equipmentMge', icon: 'devices', noCache: true},
      setName: 'V3_0_DeviceManage',
      children: [{
        path: 'processorManager',
        component: '/equipmentMge/index',
        name: 'processorManager',
        meta: {title: 'processorManager', chineseName: '管理后台-设备管理-设备管理'}
      },
        {
          path: 'repairLog',
          component: '/repairLog/index',
          name: 'repairLog',
          meta: {title: 'RepairLog', chineseName: '管理后台-设备管理-报修日志'},
          setName: 'V3_0_DeviceManage_RepairLog'
        },
        {
          path: 'projectorCode',
          component: '/projectorDevices/index',
          name: 'projectorCode',
          meta: {title: 'projectorCode', chineseName: '管理后台-设备管理-RS232码管理'},
          setName: 'V3_0_DeviceManage_AddDevice'
        },
        {
          path: 'acCode',
          component: '/acCode/index',
          name: 'acCode',
          meta: {title: 'acCode', chineseName: '管理后台-设备管理-空调码管理'},
          setName: 'V3_0_DeviceManage_RepairLog'
        },
        {
          path: 'remoteControl',
          component: '/remoteControl/index',
          name: 'remoteControl',
          meta: {title: 'remoteControl', chineseName: '管理后台-设备管理-智能遥控码管理'},
          setName: 'V3_0_DeviceManage_RepairLog'
        },
        // {
        //   path: 'interfaceRename',
        //   component: '/equipmentMge/editName',
        //   name: 'interfaceRename',
        //   meta: {title: 'interfaceRename', chineseName: '管理后台-设备管理-接口重命名'},
        //   setName: 'V3_0_DeviceManage_AddDevice'
        // },
        {
          path: 'Automation',
          component: '/equipmentMge/Automation',
          name: 'Automation',
          meta: {title: 'Automation', chineseName: '管理后台-设备管理-自动化控制'},
          setName: 'V3_0_DeviceManage_AddDevice'
        },
        {
          path: 'InputSourcesLinkage',
          component: '/equipmentMge/InputSourcesLinkage',
          name: 'InputSourcesLinkage',
          meta: {title: 'InputSourcesLinkage', chineseName: '管理后台-设备管理-输入源切换联动'},
          setName: 'V3_0_DeviceManage_AddDevice'
        },
      ]
    },
  },
  {
    name: 'V3_0_CardManageCenter',
    routes: {
      path: '',
      name: "cardMge",
      component: 'Layout',
      // redirect: 'cardMge',
      meta: {title: 'cardMge', icon: 'card', noCache: true},
      setName: 'V3_0_CardManageCenter',
      children: [
        {
          path: 'CardMge',
          component: '/cardMge/index',
          name: 'CardMge1',
          meta: {title: 'cardManager', chineseName: '管理后台-卡管理-卡管理'}
        },
        {
          path: 'cardLog',
          component: '/cardMge/cardLog',
          name: 'cardLog',
          meta: {title: 'cardLog', chineseName: '管理后台-卡管理-卡管理日志'},
          setName: 'V3_0_CardManageCenter_RepairLog'
        }

      ]
    },
  },

  {
    name: 'V3_0_CardManageCenter',
    routes: {
      path: '',
      name: "meetings",
      component: 'Layout',
      // redirect: 'cardMge',
      meta: {title: 'meetingManager', icon: 'meeting', noCache: true},
      setName: 'V3_0_CardManageCenter',
      children: [
        {
          path: 'MeetMge',
          component: '/meetings/index',
          name: 'meetingRoomManager',
          meta: {title: 'meetingRoomManager', chineseName: '管理后台-会议管理-会议室管理'}
        },
        {
          path: 'MeetDoorMge',
          component: '/meetings/MeetDoor',
          name: 'meetingDoorManager',
          meta: {title: 'meetingDoorManager', chineseName: '管理后台-会议管理-会议室门牌管理'},
          setName: 'V3_0_CardManageCenter_RepairLog'
        }

      ]
    },
  },
  // {
  //   name:'V3_0_CardManageCenter',
  //   routes:{
  //     path: '',
  //     component: 'Layout',
  //     meta: { title: 'Cards', icon: 'devices', noCache: true },
  //     setName:'V3_0_CardManageCenter',
  //     children: [{
  //       path: 'CardMge',
  //       component: '/cardMge/index',
  //       name: 'CardMge1',
  //       meta: { title: 'cardManager'}
  //     },
  //       { path: 'cardLog', component: '/cardMge/cardLog', name: 'cardLog', meta: { title: 'cardLog'},setName:'V3_0_CardManageCenter_RepairLog'},
  //     ]
  //   },
  // },
  {
    name: 'V3_0_IQManageCenter_MediaDeviceManage',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'workstationMge',
        component: '/workstationMge/index',
        name: 'workstationMge',
        meta: {title: 'workstationMge', icon: 'mediastation', noCache: true, chineseName: '管理后台-媒体工作站管理'}
      }]
    },
  },
  {
    name: 'V3_0_IQManageCenter_CloudSpaceManage',
    routes: {
      path: '',
      component: 'Layout',
      name: 'cloudDiskMge',
      children: [
        {
          path: 'cloudDiskMge',
          component: '/cloudDiskMge/index',
          name: 'cloudDiskMge',
          meta: {title: 'cloudDiskMge', icon: 'clouddrive', chineseName: '管理后台-云盘管理'}
        },
        // { path: 'storageMge', component: () => import('@/views/cloudDiskMge/storageMge'), name: 'storageMge', meta: { title: 'storageMge' }}
      ]
    },
  },
  // {
  //   name:'V3_0_IQManageCenter_LoggerManage',
  //   routes:{
  //     path: '',
  //     component: 'Layout',
  //     children: [{
  //       path: 'operationLog',
  //       component: '/operationLog/index',
  //       name: 'operationLog',
  //       meta: { title: 'operationLog', icon: 'operationlog', noCache: true }
  //     }]
  //   }
  // },
  {
    name: 'V3_0_IQManageCenter_Setting',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'customize',
        component: '/customize/index',
        name: 'customize',
        meta: {title: 'customize', icon: 'customize', noCache: true, chineseName: '管理后台-自定义'}
      }]
    }
  },
  {
    name: 'V3_0_IQManageCenter_Setting',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'setting',
        component: '/setting/index',
        name: 'setting',
        meta: {title: 'setting', icon: 'setting', noCache: true, chineseName: '管理后台-系统设置'}
      }]
    }
  },


]


export const asyncRouterMap = []



// WEBPACK FOOTER //
// ./src/router/index.js